import {AfterViewInit, Component, OnInit} from '@angular/core';
import {BaseComponent} from '../../base/base.component';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {TranslateService} from '@ngx-translate/core';
import {User} from "../../model/user/user";
import {UserService} from "../../service/user.service";
import {environment} from "../../../environments/environment";

declare var $: any;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent extends BaseComponent implements OnInit, AfterViewInit {
    user: User;
    navBarShort = false;
    btnNew = false;
    btnNewBusiness = false;
    btnGenfar = false;
    btnProductsLatam = false;
    btnFinishedProducts = false;
    btnFinishedProductsPartner = false;
    btnBulk = false;
    btnNewProductsBr = false;

    version = environment.version;

    isProduction = environment.production;

    constructor(public router: Router,
                public loading: NgxSpinnerService,
                public translate: TranslateService,
                public userService: UserService) {
        super(router, loading, translate);
    }

    ngOnInit(): void {
        this.handlerCollapse();
        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;
                this.btnNew = data.profile === 'commercial' || data.profile === 'administrator';
                this.btnNewBusiness = data.profile === 'new_business' || data.profile === 'administrator';
                this.btnGenfar = data.profile === 'commercial_genfar' || data.profile === 'administrator';
                this.btnProductsLatam = data.profile === 'commercial' || data.profile === 'administrator';
                this.btnFinishedProducts = data.profile === 'product_commercial' || data.profile === 'administrator';
                this.btnFinishedProductsPartner = data.profile === 'product_commercial' || data.profile === 'administrator';
                this.btnBulk = data.profile === 'product_commercial' || data.profile === 'administrator';
                this.btnNewProductsBr = data.profile === 'product_commercial' || data.profile === 'administrator';
            }, error: err => super.onError(err)
        });

    }

    ngAfterViewInit(): void {
        this.navActive();
    }

    handlerCollapse() {
        $('.navbar-nav .nav-item').click(function () {
            $('.navbar-nav .nav-item').removeClass('active');
            $(this).addClass('active');
        });
        $('.navbar-nav .nav-link').click(function () {
            $('.navbar-nav .nav-link').removeClass('text-white');
            $(this).addClass('text-white');
        });
    }

    actionCloseCollapse() {
        this.actionSideBar();
        $('#reports').collapse('hide');
        $('#help').collapse('hide');
        $('body').removeClass('nav-open');
        $('.hamburger').removeClass('open');
    }

    navActive() {
        if (this.router.url === '/calibration' || this.router.url === '/engines') {
            return this.handlerNavActive('.report-ts');
        }
        if (this.router.url === '/training' || this.router.url === '/faq') {
            return this.handlerNavActive('.help-ts');
        }
    }

    handlerNavActive(el) {
        $('.navbar-nav .nav-item').removeClass('active');
        $('.navbar-nav .nav-link').removeClass('text-white');
        $(el).addClass('active');
        $(el + ' .nav-link').addClass('text-white');

    }

    actionSideBar() {
        this.navBarShort = !this.navBarShort;
    }

    actionLogout() {
        const p = window.location.pathname.split('/');
        // const virtualPath = p.length >= 3 ? '/' + p[1] : '';
        const redirectUrl = window.location.origin + '/logout';
        const logoutURL = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + redirectUrl;
        window.location.href = logoutURL;
    }

    protected readonly environment = environment;
}
